import styled, { css } from "styled-components";

export const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacingM);

  > img {
    border-radius: var(--spacingL);
    height: 224px;
    object-fit: cover;
  }

  > h1 {
    text-align: center;
    font-size: 24px;
    line-height: 32px;
    color: var(--primary800);
    font-weight: 300;
    font-style: normal;
    margin: 0px;
    padding: var(--spacingM) 0px;
    width: 100%;
    overflow-wrap: break-word;
    hyphens: manual;
  }

  @media screen and (min-width: 1128px) {
    flex-direction: ${({ hasImage }) => (hasImage ? "row-reverse" : "column")};

    > img {
      flex-shrink: 0;
    }

    > h1 {
      font-size: 72px;
      line-height: 80px;
    }

    ${({ hasImage }) =>
      hasImage &&
      css`
        flex-direction: "column";
        > img {
          height: 384px;
          width: 50%;
          flex-shrink: 0;
        }

        > h1 {
          font-size: 72px;
          line-height: 80px;
          width: 50%;
        }
      `}
  }
`;
